export class FiltroBuscaGto {
    constructor(
    	public tipoBusca?: string,
    	public nPagina?: number,
        public numero?: string,
        public codigoBeneficiario?: string,
        public nomeBeneficiario?: string,
        public status?: any,
        public prestadorExecutante?: any,
        public dataInicial?: Date,
        public dataFinal?: Date,
        public dataFinalizacao?: string,
        public possuiObservacao?: boolean
        ){}
}


// WEBPACK FOOTER //
// ./src/app/components/base/vo/filtro-busca-gto.ts